import { render, staticRenderFns } from "./OrganizationLabel.vue?vue&type=template&id=37392cc1"
import script from "./OrganizationLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationLabel.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports